import { ExpertiseReportType } from 'communication/types/expertise/ExpertiseReportType';
import { ExpertiseStreamRequest } from 'communication/types/expertise/ExpertiseStreamRequest';
import { AppSettingsState } from 'app/store/appSettings/AppSettingsState';
import State from 'store/State';
import { PortfolioSelectionWrapper } from 'portfolio/PortfolioSelectionWrapper';

export function createExpertiseStreamRequest(
    reportType: ExpertiseReportType
): (
    orderIds: string[],
    _portfolioSelection: PortfolioSelectionWrapper,
    _widgetKey: string,
    appSettings: AppSettingsState,
    _state: State
) => ExpertiseStreamRequest | undefined {
    return (orderIds, _widgetKey, _appSettings, _state) => ({
        orderIds: orderIds.join(),
        reportType,
    });
}
